export default class Transform {
  position: Float32Array;
  rotation: Float32Array;
  scale: Float32Array;
  model_matrix: Float32Array;

  constructor() {
    this.position = new Float32Array([0, 0, 0]);
    this.rotation = new Float32Array([0, 0, 0]);
    this.scale = new Float32Array([1, 1, 1]);
    this.model_matrix = new Float32Array(16);
    this.identity();
  }

  identity() {
    const m = this.model_matrix;
    m[0] = 1; m[1] = 0; m[2] = 0; m[3] = 0;
    m[4] = 0; m[5] = 1; m[6] = 0; m[7] = 0;
    m[8] = 0; m[9] = 0; m[10] = 1; m[11] = 0;
    m[12] = 0; m[13] = 0; m[14] = 0; m[15] = 1;
  }

  set_from_matrix(m: Float32Array): void {
  this.position[0] = m[12];
  this.position[1] = m[13];
  this.position[2] = m[14];

  this.model_matrix.set(m);
}

  set_position(x: number, y: number, z: number) {
    this.position[0] = x;
    this.position[1] = y;
    this.position[2] = z;
  }

  set_rotation(x: number, y: number, z: number) {
    this.rotation[0] = x;
    this.rotation[1] = y;
    this.rotation[2] = z;
  }

  set_scale(x: number, y: number, z: number) {
    this.scale[0] = x;
    this.scale[1] = y;
    this.scale[2] = z;
  }

  set_scale_uniform(s: number) {
    this.set_scale(s, s, s);
  }

  translate(dx: number, dy: number, dz: number) {
    this.position[0] += dx;
    this.position[1] += dy;
    this.position[2] += dz;
  }

  rotate(rx: number, ry: number, rz: number) {
    this.rotation[0] += rx;
    this.rotation[1] += ry;
    this.rotation[2] += rz;
  }

  update_matrix() {
    const sx = this.scale[0];
    const sy = this.scale[1];
    const sz = this.scale[2];

    const rx = this.rotation[0];
    const ry = this.rotation[1];
    const rz = this.rotation[2];

    const px = this.position[0];
    const py = this.position[1];
    const pz = this.position[2];

    const cx = Math.cos(rx), sxr = Math.sin(rx);
    const cy = Math.cos(ry), syr = Math.sin(ry);
    const cz = Math.cos(rz), szr = Math.sin(rz);

    const m00 = cz * cy;
    const m01 = cz * syr * sxr - szr * cx;
    const m02 = cz * syr * cx + szr * sxr;

    const m10 = szr * cy;
    const m11 = szr * syr * sxr + cz * cx;
    const m12 = szr * syr * cx - cz * sxr;

    const m20 = -syr;
    const m21 = cy * sxr;
    const m22 = cy * cx;

    const m = this.model_matrix;

    m[0] = m00 * sx;  m[1] = m01 * sx;  m[2] = m02 * sx;  m[3] = 0;
    m[4] = m10 * sy;  m[5] = m11 * sy;  m[6] = m12 * sy;  m[7] = 0;
    m[8] = m20 * sz;  m[9] = m21 * sz;  m[10] = m22 * sz; m[11] = 0;
    m[12] = px;       m[13] = py;       m[14] = pz;       m[15] = 1;
  }

  get_right(): Float32Array {
  const m = this.model_matrix;

  let x = m[0];
  let y = m[1];
  let z = m[2];

  const len = Math.hypot(x, y, z);
  if (len > 0.000001) {
    x /= len;
    y /= len;
    z /= len;
  }

  return new Float32Array([x, y, z]);
}

get_forward(): Float32Array {
    const m = this.model_matrix;

    let x = -m[8];
    let y = -m[9];
    let z = -m[10];

    const len = Math.hypot(x, y, z);
    if (len > 0.000001) {
      x /= len;
      y /= len;
      z /= len;
    }

    return new Float32Array([x, y, z]);
  }

  get_up(): Float32Array {
  const m = this.model_matrix;

  let x = m[4];
  let y = m[5];
  let z = m[6];

  const len = Math.hypot(x, y, z);
  if (len > 0.000001) {
    x /= len;
    y /= len;
    z /= len;
  }

  return new Float32Array([x, y, z]);
}

get_forward_xz(): Float32Array {
  const m = this.model_matrix;

  let x = -m[8];
  let z = -m[10];

  const len = Math.hypot(x, z);
  if (len > 0.000001) {
    x /= len;
    z /= len;
  } else {
    x = 0;
    z = -1;
  }

  return new Float32Array([x, 0, z]);
}
}